// extracted by mini-css-extract-plugin
module.exports = {"parameters":"parameters_editor__parameters___2Gvm6"};